import { makeAutoObservable } from "mobx";
import { toast } from "../components/ui/toast";

export default class CampaignsStore {
  campaigns: any[] = [];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  fetchCampaigns = async () => {
    try {
      this.isLoading = true;
      // API call would go here
      this.campaigns = [];
    } catch (error: any) {
      toast.error(error.message || "Error fetching campaigns");
    } finally {
      this.isLoading = false;
    }
  };

  createCampaign = async (campaignData: any) => {
    try {
      // API call would go here
      toast.success("Campaign created successfully");
    } catch (error: any) {
      toast.error(error.message || "Error creating campaign");
    }
  };

  updateCampaign = async (id: string, campaignData: any) => {
    try {
      // API call would go here
      toast.success("Campaign updated successfully");
    } catch (error: any) {
      toast.error(error.message || "Error updating campaign");
    }
  };

  deleteCampaign = async (id: string) => {
    try {
      // API call would go here
      toast.success("Campaign deleted successfully");
    } catch (error: any) {
      toast.error(error.message || "Error deleting campaign");
    }
  };
}
